/**
 * useTracking — eigene Behavior-Pipeline neben useAnalytics (GA4).
 *
 * - Auto-Pageview bei Route-Wechsel
 * - login/logout-Event bei Auth-Änderung
 *
 * `useAnalytics` und `useTracking` laufen parallel und ergänzen sich:
 * GA4 für aggregierte Akquise/Channel, eigene Pipeline für User-spezifische
 * Journey-Analyse in Mission Control.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { track } from '../services/eventTracking.service';

export default function useTracking() {
  const location = useLocation();
  const { user } = useAuth();
  const lastUid = useRef(null);

  useEffect(() => {
    track('pageview', {
      path: location.pathname + location.search,
      title: typeof document !== 'undefined' ? document.title : null
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    const uid = user?.firebaseUid || null;
    if (uid && uid !== lastUid.current) {
      lastUid.current = uid;
      track('login', { user_level: user.level || 1 });
    } else if (!uid && lastUid.current) {
      track('logout', {});
      lastUid.current = null;
    }
  }, [user]);
}

export { track };
